import { Component, OnInit } from '@angular/core';
import { LoaderService } from './loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {

  constructor(private loaderService: LoaderService) { }
  
  show: boolean;


  ngOnInit() {
    this.loaderService.status.subscribe((value) => {
      this.show = value;
    });
  }
  
}